// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';

const paramClickString = "Click";
const paramTitleBarButtonString = "ButtonTitleBar";

$w.onReady(function () {
	//TODO: write your page related code here...

});

function trackEvent(event, category, action, label)
{
	wixWindow.trackEvent("CustomEvent", {
		"event": event,
		"eventCategory": category,
		"eventAction": action,
		"eventLabel": label
	} );
}

export function buttonTitleSteam_click(event) {
	
	trackEvent("SteamTitleBar", paramClickString, "VisitSteam", paramTitleBarButtonString)

}

export function buttonTitleGog_click(event) {

	trackEvent("GogTitleBar", paramClickString, "VisitGog", paramTitleBarButtonString)

}

export function socialBar2_mouseIn(event) {

	trackEvent("SocialBarHover", "MouseOver", "TitleBarSocialBar", "MouseIn");

}

export function buttonTitleFacebook_click(event) {
	
	trackEvent("FacebookTitleBar", paramClickString, "VisitFacebook", paramTitleBarButtonString)

}

export function buttonTitleTwitter_click(event) {
	
	trackEvent("TwitterTitleBar", paramClickString, "VisitTwitter", paramTitleBarButtonString)
	
}

export function buttonTitleDiscord_click(event) {
	
	trackEvent("DiscordTitleBar", paramClickString, "VisitDiscord", paramTitleBarButtonString)
	
}

export function buttonTitleYoutube_click(event) {
	
	trackEvent("YoutubeTitleBar", paramClickString, "VisitYoutube", paramTitleBarButtonString)
	
}